export const WebsiteAccessLevel = {
  PUBLIC: 'public',
  PROTECTED: 'protected',
};
